export const ANALYSIS_AGENT_USAGE_GUIDE_PATH = "/assets/docs/dataset-agent/usage-guide.md";
export const ANALYSIS_AGENT_USAGE_GUIDE_TITLE = "AI Analysis Guide";
